export const project_index_get_project = {
  STATUS: {
    type: "string"
  },
  actionMsg: {
    type: "string"
  },
  actionResult: {
    type: "string"
  },
  projectData: {
    projectData: {
      project_environments: {
        type: "object"
      }
    },
    projects: {
      type: "array"
    }
  }
};
